import { render, staticRenderFns } from "./CardTableHis.vue?vue&type=template&id=682d232a&scoped=true"
import script from "./CardTableHis.vue?vue&type=script&lang=js"
export * from "./CardTableHis.vue?vue&type=script&lang=js"
import style0 from "./CardTableHis.vue?vue&type=style&index=0&id=682d232a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "682d232a",
  null
  
)

export default component.exports